import Apps from "./Apps"
import Games from "./Games"
import AppsAndGames from "./AppsAndGames"
import useT from "utils/useT"
import { useEffect, useState } from "react"
import useRouterStore from "stores/routerStore"
import useFiltersStore from "stores/filters"
import Tabs from "components/Tabs"
import { motion } from "framer-motion"
import Image from "next/image"
import useSessionStore from "stores/session"
import imagePlaceholder from "utils/imagePlaceholder"

const FeedPage = ({ query }: any) => {
  const t = useT()
  const asPath = useRouterStore((state) => state.router?.asPath)
  const push = useRouterStore((state) => state.router?.push)
  const switchParam = useRouterStore((state) => state.router?.query.switch)
  const priceParam = useRouterStore((state) => state.router?.query.price)
  const URLQuery = new URLSearchParams(asPath)?.entries()?.next()?.value?.[1]
  const type = query?.switch || URLQuery || switchParam || "all"
  const priceFilter = query?.price || priceParam
  const [page, setPage] = useState(type)
  const price = useFiltersStore((state) => state.price)
  const setPrice = useFiltersStore((state) => state.setPrice)
  const photoURL = useSessionStore((state) => state.user.photoURL)

  useEffect(() => {
    priceFilter && setPrice(priceFilter)
  }, [priceFilter])

  return (
    <motion.div>
      <div
        onClick={() => push?.("/submit")}
        className="card card-style p-3 feed-card"
      >
        <div>
          <Image
            key={photoURL}
            height={40}
            width={40}
            className="bg-fade-gray1-dark preload-img img-profile col"
            src={photoURL ? photoURL : "/images/avatars/4s.png"}
            alt="profile photo"
            priority
            placeholder="blur"
            blurDataURL={imagePlaceholder(true)}
            unoptimized
          />
        </div>
        <div className="ms-2 me-auto">{t.feed.write}</div>
        <button className="btn bg-blue-dark rounded-sm">{t.feed.share}</button>
      </div>
      <Tabs price={price} page={page} setPage={setPage} />
      {page === "apps" && <Apps />}
      {page === "games" && <Games />}
      {page === "all" && <AppsAndGames />}
    </motion.div>
  )
}
export default FeedPage
